export default{
	methods:{

		permission(info, opcao){

			let ret = false;

			if(typeof this.perm.perm[info] != "undefined"){
				if(this.perm.perm[info][opcao] == '1'){
					ret = true;
				}
			}

			return ret;
		},

		permissionEspecial(info){
			let ret = false;

			if(typeof this.perm.especial[info] != "undefined"){
				if(this.perm.especial[info] == '1'){
					ret = true;
				}
			}

			return ret;
		},

		permissaoCampo(sistema, campo){

			if(typeof this.perm.campo[sistema] == "undefined"){
				return false;
			}else{

				let find = this.perm.campo[sistema].find(el=>{
					return el.campo == campo;
				});

				if(typeof find == "undefined" || parseInt(find.select) == 0){
					return false;
				}else{
					return true;
				}
			}

		}

	}
};
